import { useEffect, useState } from 'react';
import Image from 'next/image';
import styles from './Certificates.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
const onSamandehiClick = () => {
  if (window.location.host.includes('shab.ir')) {
    window.open('https://logo.samandehi.ir/Verify.aspx?id=77856&p=jyoejyoemcsidshwgvka', 'Popup', 'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30');
  } else if (window.location.host.includes('shab.rentals')) {
    window.open('https://logo.samandehi.ir/Verify.aspx?id=374728&p=xlaojyoeaodsjyoeuiwkmcsi', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
  } else if (window.location.host.includes('shab.travel')) {
    // travel
    window.open('https://logo.samandehi.ir/Verify.aspx?id=239192&p=uiwkxlaopfvlrfthpfvluiwk', 'Popup', 'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30');
  }
};
const onEtehadiehClick = () => {
  window.open('https://ecunion.ir/verify/shab.ir?token=73967275c8e3ab921c5e', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
};
const onEnamadClick = () => {
  if (window.location.host.includes('shab.ir')) {
    window.open('https://trustseal.enamad.ir/?id=109813&Code=Xg4xD2XvdnYjDVHdsVOF', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
  } else if (window.location.host.includes('shab.rentals')) {
    window.open('https://trustseal.enamad.ir/?id=544125&Code=ug2TeaktEhVfwFrpMyljSZeuYDiL36RT', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
  } else if (window.location.host.includes('shab.travel')) {
    // travel
    window.open('https://trustseal.enamad.ir/?id=209414&Code=LnBiGTBG6gKMCxSmOfWK', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
  }
};
const Certificates = () => {
  const [domain, setDomain] = useState('ir');
  useEffect(() => {
    if (window.location.host.includes('shab.ir')) {
      setDomain('ir');
    } else if (window.location.host.includes('shab.rentals')) {
      setDomain('rentals');
    } else if (window.location.host.includes('shab.travel')) {
      setDomain('travel');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="Certificates" data-sentry-source-file="Certificates.tsx">
      <Typography component={'h5'} variant={'title'} data-sentry-element="Typography" data-sentry-source-file="Certificates.tsx">
        با خیال راحت به ما اعتماد کنید
      </Typography>
      <Box className={styles['images']} data-sentry-element="Box" data-sentry-source-file="Certificates.tsx">
        {domain === 'ir' && <Image width={105} height={105} onClick={onEtehadiehClick} src="https://api.shab.ir/img/namad.png" loader={() => 'https://api.shab.ir/img/namad.png'} alt="نماد" loading="lazy" style={{
        cursor: 'pointer'
      }} />}

        <Image width={105} height={105} src={domain === 'ir' ? '/images/footer/enamad-five-star.png' : '/images/footer/enamad.png'} onClick={onEnamadClick} alt="اینماد" loading="lazy" referrerPolicy="origin" style={{
        cursor: 'pointer'
      }} data-sentry-element="Image" data-sentry-source-file="Certificates.tsx" />
        {(domain === 'ir' || domain === 'rentals') && <Image width={105} height={105} onClick={onSamandehiClick} src={'/images/footer/samandehi.png'} alt="ساماندهی" loading="lazy" style={{
        cursor: 'pointer'
      }} />}
      </Box>
    </Box>;
};
export default Certificates;